import React, { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import CustomAudioPlayer from '../ui/CustomAudioPlayer';

export function useAudioHydration(containerRef, dependencies = []) {
    const rootsRef = useRef(new Map());

    useEffect(() => {
        if (!containerRef.current) return;

        const hydrate = () => {
            // Limpieza de nodos que ya no están en el DOM (ej: al reemplazar innerHTML)
            rootsRef.current.forEach((root, domNode) => {
                if (!document.body.contains(domNode)) {
                    setTimeout(() => {
                        try { root.unmount(); } catch(e) {}
                    }, 0);
                    rootsRef.current.delete(domNode);
                }
            });

            const mounts = containerRef.current.querySelectorAll('.cy-embed-audio-mount:not([data-mounted="true"])');
            
            mounts.forEach(mount => {
                mount.setAttribute('data-mounted', 'true');
                const src = mount.getAttribute('data-src');
                const filename = mount.getAttribute('data-filename');

                const root = createRoot(mount);
                root.render(<CustomAudioPlayer src={src} filename={filename} />);
                rootsRef.current.set(mount, root);
            });
        };

        // Hydrate inicial
        hydrate();

        // Observa cualquier cambio futuro en el DOM (ej: si dangerouslySetInnerHTML pisa todo el contenedor)
        const observer = new MutationObserver(() => {
            hydrate();
        });

        observer.observe(containerRef.current, {
            childList: true,
            subtree: true
        });

        return () => {
            observer.disconnect();
            // Limpieza final
            rootsRef.current.forEach(root => {
                setTimeout(() => {
                    try { root.unmount(); } catch(e) {}
                }, 0);
            });
            rootsRef.current.clear();
        };
    }, dependencies);
}
